import { BaseBlockOptions } from "sb-resp-lib";
import { sportConfig, datesConfig, liveStreamingMode } from "../../../modes";
import { queryType } from "../../../common";

export type sportViewConfig = {
    hideSportIconOnMobile: boolean,
    alternative: boolean,
    colorful: boolean,
    iconSize?: number
}

export type sportBlockConfig = sportConfig & sportViewConfig & { mode: "Sport" }
export type datesBlockConfig = datesConfig & { mode: "Dates" }
export type blockConfig = sportBlockConfig | datesBlockConfig;

export const config: sportBlockConfig = {
    alternative: false,
    colorful: false,
    mode: "Sport",
    enableAllSports: false,
    enableFavorites: false,
    isFavoritesFirst: true,
    liveStreamingMode: liveStreamingMode.firstSelected,
    enableLiveStreaming: false,
    sportOrder: [],
    blockId: "filter_block",
    query: queryType.preLive,
    hideSportIconOnMobile: true,
    sportRetrieverUpdatePeriod: 180000,
    liveStreamingUpdatePeriod: 30000,
};

export type FilterBlockOptions = BaseBlockOptions & {
    cms: blockConfig;
}